/** @flow */

import type { UserAccountsState } from "./types";

export const setLoading = (state: UserAccountsState) => () => ({
  ...state,
  requestsInProgress: ++state.requestsInProgress,
});

export const onGetUserAccountsSuccess = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  list: payload,
  error: null,
});

export const onGetUserAccountsError = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: payload,
});

export const onExportUserAccountsSuccess = (state: UserAccountsState) => () => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: null,
});

export const onExportUserAccountsError = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: payload,
});
